import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';
import { previewHistoryBatch } from '../../../../store/extensions';
import { getMaxPositionForAspectRatio } from '../imageElementSizeCalculations';

const ImageElementPositionListItem = (props) => {
    const { imagePositionX, imagePositionY, index, updateImageElement, maxXPosition, maxYPosition } = props;

    const onPositionXChange = (value) => {
        previewHistoryBatch.start();
        updateImageElement(index, { position: { x: value } });
    };

    const onPositionYChange = (value) => {
        previewHistoryBatch.start();
        updateImageElement(index, { position: { y: value } });
    };

    return (
        <CondensedListItem
            elements={[
                {
                    width: 6,
                    component: <SliderListItem
                        title='X Position'
                        value={imagePositionX}
                        displayMultiplier={1}
                        min={-maxXPosition}
                        max={maxXPosition}
                        step={1}
                        onValueChange={onPositionXChange}
                        onSliderChangeCommitted={() => previewHistoryBatch.end()}
                        onInputFocusIn={() => previewHistoryBatch.start()}
                        onInputFocusOut={() => previewHistoryBatch.end()}
                    />
                },
                {
                    width: 6,
                    component: <SliderListItem
                        title='Y Position'
                        value={imagePositionY}
                        displayMultiplier={-1}
                        min={-maxYPosition}
                        max={maxYPosition}
                        step={1}
                        onValueChange={onPositionYChange}
                        onSliderChangeCommitted={() => previewHistoryBatch.end()}
                        onInputFocusIn={() => previewHistoryBatch.start()}
                        onInputFocusOut={() => previewHistoryBatch.end()}
                    />
                }
            ]}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const { videoSettings } = state.createPreview.present;
    const imageElement = (videoSettings.elements.imageElements || videoSettings.elements.images)[ownProps.index];

    // The travel a picture is given has to match the frame it is being placed in, not the widest one
    // the app can render: the landscape limits the API serves would take a picture right off the
    // canvas in a portrait or square frame, and put the slider out of step with what a drag allows.
    const { maxXPosition, maxYPosition } = getMaxPositionForAspectRatio(videoSettings.aspectRatio);

    return {
        imagePositionX: imageElement.position.x,
        imagePositionY: imageElement.position.y,
        maxXPosition,
        maxYPosition
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateImageElement = (index, properties) => dispatch(createActions.updateImageElement(index, properties));
    return { updateImageElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageElementPositionListItem);
